export const customerPasswordRegExp = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?!.* ).{8,}$/;
export const invalidPasswordMsg =
  'The password must be at least 8 characters long and must contain at least: 1 uppercase or lowercase letter, 1 number';
